export default "__VITE_ASSET__CbBTTqYo__"